const cloudProvidersState = {
    cloudProviders: undefined,
    requestingCloudProviders: false
};
export default cloudProvidersState;
